export { default } from './GalleryBlock';
